import HomeRoute from './screens/Home/route';
import AuthRoute from './screens/Auth/route';
import ProductRoute from './screens/Products/route';
import ProductDetailsRoute from './screens/ProductDetails/route';
import AccountRoute from './screens/Account/route';
import CartRoute from './screens/Cart/route';
import CheckoutRoute from './screens/Checkout/route';
import PaymentRoute from './screens/Payment/route';
import OrderSuccessRoute from './screens/OrderSuccess/route';
import SubmitReviewRoute from './screens/SubmitReview/route';
import EditReviewRoute from './screens/EditReview/route';

const screenRoutes = [
  HomeRoute,
  AuthRoute,
  ProductRoute,
  ProductDetailsRoute,
  AccountRoute,
  CartRoute,
  CheckoutRoute,
  PaymentRoute,
  OrderSuccessRoute,
  SubmitReviewRoute,
  EditReviewRoute,
];

export default screenRoutes;
